<mat-sidenav-container class="help-drawer-container" hasBackdrop="true">
  <mat-sidenav class="help-drawer-body" #sidenav position="end">
    @if (getHelpContent) {
      <div class="help-drawer-body__close" (click)="sidenav.toggle()">
        <img [src]="blobURL + getHelpContent.closeIcon">
      </div>
    }
    @if (getHelpContent) {
      <div class="help-drawer-body__section">
        <h3 class="help-drawer-body__section-header">{{getHelpContent.title}}</h3>
        <p class="help-drawer-body__section-text">{{getHelpContent.text}}</p>
        <div class="help-drawer-body__section-item">
          @for (issue of getHelpContent.issuesToBeReported; track issue) {
            <div>
              @if (issue.enableInQuoteFlow) {
                <div>
                  <cb-accordion cueType="caret" colorTheme="blue">
                    <cb-accordion-panel>
                      <cb-accordion-header>{{issue.title}}</cb-accordion-header>
                      <cb-accordion-content>
                        @for (content of issue.contentList; track content) {
                          <div class="help-drawer-body__section-item--container">
                            @if (!hideContactNum(content)) {
                              <div>
                                <h4 class="help-drawer-body__section-item--title">{{content.title}}</h4>
                                <p class="help-drawer-body__section-item--text">
                                  @for (subItem of content.subContent; track subItem) {
                                    <span>
                                      @if (subItem.type === 'image') {
                                        <img [src]="blobURL + subItem.url">
                                      }
                                      @if (subItem.type === 'string') {
                                        <label>{{subItem.text}}</label>
                                      }
                                      @if (subItem.type === 'link') {
                                        <a href="{{subItem.url}}" target="_blank">
                                          {{subItem.text}}
                                        </a>
                                      }
                                    </span>
                                  }
                                </p>
                              </div>
                            }
                          </div>
                        }
                        @if (issue.navigationItems && (issue.navigationItems.length > 0)) {
                          <div class="help-drawer-body__section-item--navigation">
                            @for (navItem of issue.navigationItems; track navItem) {
                              <div>
                                @if ((navItem.type === 'button') && displayNavButtons(navItem)) {
                                  <button class="help-drawer-body__section-item--navigation-btn" type="button" mat-button
                                  (click)="sendEmailstoCustomer(navItem)">{{navItem.text}}</button>
                                }
                                @if ((navItem.type === 'link') && displayNavButtons(navItem)) {
                                  <a class="help-drawer-body__section-item--navigation-link" (click)="sendEmailstoCustomer(navItem)">{{navItem.text}}</a>
                                }
                              </div>
                            }
                          </div>
                        }
                      </cb-accordion-content>
                    </cb-accordion-panel>
                  </cb-accordion>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (getHelpContent) {
      <div class="help-drawer-body__navigation">
        <button class="help-drawer-body__navigation-btn" type="button" mat-button
          (click)="sidenav.toggle()">
          {{getHelpContent.closeBtnText}}
        </button>
      </div>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="nav-wrapper">
      <app-navbar class="navbar" id="navbar" (openHelpDrawer)="sidenav.toggle()"></app-navbar>
      <div class="content-wrapper" id="content-wrapper" (scroll)="onWindowScroll($event);">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
      <app-footer></app-footer>
      <button class="help-drawer-btn get-help" type="button" mat-button (click)="sidenav.toggle()">
        <img src="../../../assets/img/icons/help.svg">
        <label>Need help?</label>
      </button>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (commonCommunicationService.showSpinner) {
  <div class="overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
